import React, { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useForm } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { RotatingLines } from 'react-loader-spinner';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import CommonButton, { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';
import CommonTooltip from '../../../../../components/common-tooltip/CommonTooltip';
import { ASSISTANT_TYPES } from '../../../../../constants';
import WithError from '../../../../../components/with-error/WithError';

import scss from './DocsButton.module.scss';

function DocsButton({ selectedTypeOption, onFileUpload, disabled, isLoading }) {
  const { t } = useTranslation('scout');
  const dispatch = useDispatch();

  const form = useForm();
  const prevAssistantId = useRef('');

  const [fileName, setFileName] = useState('');
  const hiddenFileInput = useRef(null);

  const handleOpenChooseFile = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const response = await dispatch(onFileUpload(file));
      form.change('fileText', response.payload);
    }
  };

  useEffect(() => {
    if (
      selectedTypeOption?.id &&
      prevAssistantId.current !== selectedTypeOption?.id &&
      selectedTypeOption?.type === ASSISTANT_TYPES.FILE
    ) {
      prevAssistantId.current = selectedTypeOption?.id;
    }

    if (selectedTypeOption?.id && selectedTypeOption?.type !== ASSISTANT_TYPES.FILE) {
      setFileName('');
      form.change('fileText', '');
      hiddenFileInput.current.value = '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTypeOption]);

  return (
    <Field name='docs' type='file'>
      {({ meta, input }) => (
        <div className={scss.wrapper}>
          <WithLabel variant={LABEL_STYLES.ROW} label={t('docs')} isBold extraClassName={scss.buttonLabel}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTooltip title={disabled ? '' : t('upload')}>
                <div>
                  <CommonButton styleColor={BUTTON_STYLES.SECONDARY} onClick={handleOpenChooseFile} disabled={disabled}>
                    {isLoading ? (
                      <RotatingLines
                        strokeColor='#fdbf47'
                        strokeWidth='5'
                        animationDuration='0.75'
                        width={16}
                        visible={true}
                      />
                    ) : (
                      <Icon icon={ICONS.ImportIcon} />
                    )}
                  </CommonButton>
                </div>
              </CommonTooltip>

              <input
                type='file'
                name={input.name}
                onChange={handleFileChange}
                ref={hiddenFileInput}
                style={{ display: 'none' }}
              />
            </WithError>
          </WithLabel>

          {fileName ? <span className={scss.fileName}>{fileName}</span> : null}
        </div>
      )}
    </Field>
  );
}

export default memo(DocsButton);
